import React, { useState, useEffect } from "react";
import Layout from "../components/layout";
import styled from "styled-components";
import SEO from "../components/seo";
import Images from "../components/Gallery/images";
import Img1 from "../images/pageImages/Homepage/student.jpg";
import Img2 from "../images/pageImages/Homepage/university.jpg";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import ReactGA from "react-ga";
import axios from "axios";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import Loader from "../components/Reusables/Loader";
const StyledWrapper = styled.div`
  .carousel-heading {
    text-decoration: uppercase;
    font-family: ${props => props.theme["primaryFont"]} !important;
  }

  .bottom-div {
    color: ${props => props.theme["borderBottomColor"]};
  }
  .end-div {
    font-size: 48px;
    color: ${props => props.theme["borderBottomColor"]};
    text-decoration: underline;
    font-weight: 800;
    @media (max-width: 600px) {
      font-size: 28px;
    }
  }
`;

const images = [
  {
    year: "2018",
    image: `${Img1}`,
    size: "sm",
  },
  {
    year: "2019",
    image: `${Img2}`,
    size: "md",
  },
  {
    year: "2018",
    image: `${Img2}`,
    size: "sm",
  },
  {
    year: "2018",
    image: `${Img1}`,
    size: "sm",
  },
  {
    year: "2018",
    image: `${Img2}`,
    size: "lg",
  },
  {
    year: "2018",
    image: `${Img2}`,
    size: "md",
  },
  {
    year: "2018",
    image: `${Img2}`,
    size: "sm",
  },
  {
    year: "2018",
    image: `${Img1}`,
    size: "sm",
  },
  {
    year: "2019",
    image: `${Img1}`,
    size: "sm",
  },
  {
    year: "2019",
    image: `${Img1}`,
    size: "md",
  },
  {
    year: "2018",
    image: `${Img2}`,
    size: "lg",
  },
  {
    year: "2019",
    image: `${Img1}`,
    size: "sm",
  },
];
const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Gallery />
    </QueryClientProvider>
  );
}
const fetchData = () => {
  return axios.get(`${process.env.GATSBY_API_URL}/gallerypage`);
};

const Gallery = () => {
  const [newData, setNewData] = useState(null);
  const { data: pageData } = useQuery("gallerydata", fetchData);
  useEffect(() => {
    if (pageData !== undefined) {
      setNewData(pageData.data);
    }
  }, [pageData]);
  const handleClick = () => {
    ReactGA.event({
      category: "Gallery Page",
      action: "Get in Touch Button Click",
    });
  };
  return (
    <Layout>
      <StyledWrapper>
        {newData === null && <Loader />}
        {newData && <SEO title={newData.SEOtitle} />}
        {newData && newData.showImage && newData.Image.length > 0 && (
          <Images data={newData.Image} />
        )}
        {newData && newData.CtaButton && (
          <div
            className="container-fluid bottom-div mt-0"
            style={{ background: newData.CtaButton.bgColor }}
          >
            <div className="col-12 py-4 d-flex justify-content-center">
              <AnchorLink
                to={newData.CtaButton.link}
                className="end-div"
                onAnchorLinkClick={handleClick}
              >
                {newData.CtaButton.title}
              </AnchorLink>
            </div>
          </div>
        )}
      </StyledWrapper>
    </Layout>
  );
};
